import React from 'react';

/**
 * PollViewTabs - Toggle between "My Polls" and "Received" views
 * Similar to the Feed/Sources toggle on the dashboard
 */
const PollViewTabs = ({ 
  pollView, 
  setPollView, 
  myPollsCount, 
  receivedCount 
}) => {
  return (
    <div className="flex items-center bg-black/20 rounded-lg p-1">
      <button
        onClick={() => setPollView('my')}
        data-testid="my-polls-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          pollView === 'my' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        My Polls
        {myPollsCount > 0 && (
          <span className={`ml-1.5 ${pollView === 'my' ? 'text-slate-500' : 'text-white/50'}`}>
            ({myPollsCount})
          </span>
        )}
      </button>
      <button
        onClick={() => setPollView('received')}
        data-testid="received-polls-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          pollView === 'received' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        Received
        {receivedCount > 0 && (
          <span className={`ml-1.5 ${pollView === 'received' ? 'text-slate-500' : 'text-white/50'}`}>
            ({receivedCount})
          </span>
        )}
      </button>
    </div>
  );
};

export default PollViewTabs;
